// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"6f85b838","453":"207a859a","464":"6caadf46"}[chunkId] + ".chunk.js";
};